import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {RootState} from 'modules';
import {selectSectionAction} from 'modules/timeline';
import useEventListener from 'hooks/useEventListener';
import Section from 'components/footer/Section';

/**
 * 편집 구간 선택 컨테이너
 */

const SectionContainer = () => {
  const dispatch = useDispatch();
  const {
    timeline: {sectionIdx, sectionLists},
  } = useSelector(({timeline}: RootState) => ({timeline}));
  const [listsClass, setListsClass] = useState('');
  const [sectionTitle, setSectionTitle] = useState({
    idx: 0,
    time: 0,
  });

  /**
   * 구간 리스트 로드
   */
  useEffect(() => {
    if (!sectionLists[sectionIdx]) return;
    // 구간 리스트 로드 시, 빈 데이터 체크
    if (sectionLists.length <= 1 && sectionLists[0].endTime <= 0) return;

    setSectionTitle({
      idx: sectionIdx,
      time: sectionLists[sectionIdx].endTime,
    });
  }, [sectionLists, sectionIdx]);

  /**
   * 구간 리스트 선택 클릭
   */
  const onClickSectionList = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    e.preventDefault(); // a Tag때문에 넣음..

    if (listsClass === 'on') {
      setListsClass('');
    } else {
      setListsClass('on'); // 섹션 리스트 출력
    }
  };

  /**
   * 구간 선택 클릭
   */
  const onClickSection = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    e.preventDefault(); // a Tag때문에 넣음..

    const idx = Number(e.currentTarget.dataset.idx); // 선택한 구간 idx
    if (sectionIdx === idx) {
      setListsClass(''); // 구간 리스트 창 내림
      return; // 현재 보는 구간이면 리턴
    }

    setSectionTitle({
      idx,
      time: sectionLists[idx].endTime,
    }); // 구간 선택 타이틀 영역 셋팅
    setListsClass(''); // 구간 리스트 창 내림

    dispatch(selectSectionAction(idx));
  };

  const handleMouseDown = (e: any) => {
    if (e.target.dataset.name === 'section') return;

    // section 아닌 영역 클릭 시에는 셀렉트박스 닫음
    setListsClass(''); // 구간 리스트 창 내림
  };

  useEventListener('mousedown', handleMouseDown);

  return (
    <Section
      sectionTitle={sectionTitle}
      sectionLists={sectionLists}
      listsClass={listsClass}
      onClickSectionList={onClickSectionList}
      onClickSection={onClickSection}
    />
  );
};

export default SectionContainer;
